import React, {Component} from 'react';
import {Button} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {baseTokenSymbol, reactTableText} from '../constants/configs';
import ReactTableTextFilter from '../components/ReactTableTextFilter';
import ReactTableSelectFilter from "../components/ReactTableSelectFilter";
import {getStatusColor, mapStatus, numberWithCommas} from "../helpers/Utils";
import {keyBy, mapValues, omit} from 'lodash';
import Api from '../services/Api';
import ReactTable from 'react-table';
import UserInfo from "../components/UserInfo";
import Rbac from "../components/Rbac";
import ModalManager from "../components/modal/ModalManager";
import {NotificationManager} from "../components/common/react-notifications";
import IdBaseDepositsDetails from "./IdBaseDepositsDetails";
import IdBaseDepositDescriptionForm from "./IdBaseDepositDescriptionForm";

class IdBaseDeposits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deposits: [],
      pages: -1,
      loading: false,
      expanded: {},
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
  }

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  fetchData = async state => {
    const {userId} = this.props;
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/deposits/paymentIds/transactions',
        null,
        {
          params: {
            userId,
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          },
        },
      );
      this.setState({
        deposits: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'NOT_SUBMITTED ', label: t('Not Submitted')},
      {value: 'PENDING', label: t('Pending')},
      {value: 'VERIFIED', label: t('Verified')},
      {value: 'REJECTED', label: t('Rejected')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  onPressConfirm = (itemIndex, transaction) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Transaction'),
      body: t('Are you sure you want to confirm this transaction?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.confirmTransaction(transaction.id);
            ModalManager.close({
              isOpen: false
            });
            setTimeout(() => {
              this.showIdBaseDepositDescriptionForm(
                {id: transaction.id},
                transaction.description,
                itemIndex
              );
            }, 100);
          },
          text: t('Yes'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  onPressReject = (itemIndex, transaction) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Reject Transaction'),
      body: t('Are you sure you want to reject this transaction?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.rejectTransaction(transaction.id);
            ModalManager.close({
              isOpen: false
            });
            setTimeout(() => {
              this.showIdBaseDepositDescriptionForm(
                {id: transaction.id},
                transaction.description,
                itemIndex
              );
            }, 100);
          },
          text: t('Yes'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  confirmTransaction = async id => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/deposits/paymentIds/transactions/${id}`,
        {
          status: 'VERIFIED',
        },
      );
      await this.table.fireFetchData();
      NotificationManager.success(t('Transaction confirmed successfully'), t('Message'));
    } catch (e) {
      console.log("error: ", e);
    }
  };

  rejectTransaction = async id => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        `/v2/admin-ui/deposits/paymentIds/transactions/${id}`,
        {
          status: 'REJECTED',
        },
      );
      await this.table.fireFetchData();
      NotificationManager.success(t('Transaction rejected'), t('Message'));
    } catch (e) {
      console.log("error: ", e);
    }
  };

  showIdBaseDepositDescriptionForm = (values, description, index) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Transaction Description'),
      body: <IdBaseDepositDescriptionForm
        values={values}
        description={description}
        onSubmit={async data => {
          await this.updateTransaction(data, index);
        }}/>,
    });
  };

  updateTransaction = async (values, index) => {
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/deposits/paymentIds/transactions/${values.id}`, {
        description: values.description,
      });
      this.updateList(values, index);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  updateList = (values, index) => {
    const {t} = this.props;
    const {deposits} = this.state;
    let list = [...deposits];
    list.splice(index, 1, {...deposits[index], ...values});
    this.setState({deposits: list});
    NotificationManager.success(t('Transaction updated successfully'), t('Message'));
  };

  getColumns = t => [
    {
      Header: t('Payment Id'),
      accessor: 'payId',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.provider.payId}</span>,
      width: 140,
    },
    {
      Header: t('Bank Ref Id'),
      accessor: 'bankReferenceNumber',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.provider.bankReferenceNumber}</span>,
      width: 120,
    },
    {
      Header: t('External Ref Id'),
      accessor: 'externalReferenceNumber',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.provider.externalReferenceNumber}</span>,
      width: 180,
    },
    {
      Header: t('Amount') + ` (${t(baseTokenSymbol)})`,
      accessor: 'amount',
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
      width: 100,
    },
    {
      Header: t('Fee') + ` (${t(baseTokenSymbol)})`,
      accessor: 'fee',
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
      width: 100,
    },
    {
      Header: t('Destination Iban'),
      accessor: 'provider.destination.iban',
      Cell: props => <span>{`IR${props.value}`}</span>,
      width: 220,
    },
    {
      Header: t('Destination Account Owner'),
      accessor: 'provider.destination.ownerName',
      Cell: props => <span>{props.value}</span>,
      width: 120,
    },
    {
      Header: t('Internal Status'),
      accessor: 'flsStatus',
      filterable: true,
      Filter: this.renderStatusFilter,
      Cell: props => <span className={getStatusColor(props.value)}>{mapStatus(props.value)}</span>,
      width: 140,
    },
    {
      Header: t('External Status'),
      accessor: 'providerStatus',
      filterable: true,
      Filter: this.renderStatusFilter,
      Cell: props => <span className={getStatusColor(props.original.provider.status)}>{mapStatus(props.original.provider.status)}</span>,
      width: 140,
    },
    {
      Header: t('Actions'),
      width: 100,
      accessor: 'id',
      Cell: props => {
        const isEvaluated = (props.original.flsStatus === "VERIFIED" && props.original.provider.status === "VERIFIED") ||
          (props.original.flsStatus === "REJECTED" && props.original.provider.status === "REJECTED");
        if (!isEvaluated) {
          return (
            <div>
              <Rbac permission='update_bank-deposit'>
                <Button
                  outline
                  size="xs"
                  color="success"
                  onClick={() => {this.onPressConfirm(props.index, props.original);}}
                  className="text-center w-80">
                  {t('Confirm')}
                </Button>
              </Rbac>
              <Rbac permission='update_bank-deposit'>
                <Button
                  outline
                  size="xs"
                  color="danger"
                  onClick={() => {this.onPressReject(props.index, props.original);}}
                  className="text-center w-80 mt-1">
                  {t('Reject')}
                </Button>
              </Rbac>
            </div>
          );
        }
        return null;
      },
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <ReactTable
        manual
        ref={el => {this.table = el;}}
        className="-highlight"
        data={this.state.deposits}
        pages={this.state.pages}
        loading={this.state.loading}
        sortable={false}
        resizable={true}
        onFetchData={this.fetchData}
        columns={this.getColumns(t)}
        defaultPageSize={10}
        expanded={this.state.expanded}
        style={{width: '100%', marginTop: 20}}
        onPageChange={() => {this.setState({expanded: {}});}}
        onExpandedChange={this.onExpanded}
        SubComponent={row => {
          return (
            <IdBaseDepositsDetails
              itemIndex={row.index}
              transaction={row.original}
              showIdBaseDepositDescriptionForm={this.showIdBaseDepositDescriptionForm}
            />
          );
        }}
        {...reactTableText}
      />
    );
  }
}

export default withTranslation()(IdBaseDeposits);
